<template>
  <v-app>
    <v-toolbar app :dark="$route.name === 'spatial-stats'">
      <span
        ><img
          :src="require('../assets/images/logo_notext.png')"
          alt="logo"
          @click="$router.push('/')"
          style="cursor: pointer"
          contain
          class="shrink mr-2 cursor-change"
          transition="scale-transition"
          width="50"
      /></span>
      <v-spacer></v-spacer>
      <span v-if="windowWidth > 1320">
        <nav-buttons
          :auth-as-menu="windowWidth > 1320"
          @sign-out="signOut()"
          @show-tac-overlay="tac = true"
          @show-contact-overlay="contact = true"
        ></nav-buttons>
      </span>
      <v-menu v-else offset-y style="z-index: 9999;">
        <v-btn flat slot="activator">
          <v-icon>menu</v-icon>
        </v-btn>
        <v-list>
          <nav-buttons
            :auth-as-menu="windowWidth > 1320"
            @sign-out="signOut()"
            @show-tac-overlay="tac = true"
            @show-contact-overlay="contact = true"
          ></nav-buttons>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-content>
      <router-view></router-view>
    </v-content>

    <v-slide-y-transition>
      <amplify-auth
        v-show="showLogin"
        class="auth-modal"
        :admin-users="adminUsers"
        @close-auth="changeAuthModal(false)"
      ></amplify-auth>
    </v-slide-y-transition>

    <v-fade-transition>
      <div class="tac-overlay" v-show="tac">
        <div class="tac-content">
          <iframe
            class="doc-frame"
            :src=$store.state.settings.termsDocURL
          ></iframe>
          <div class="text-lg-center">
            <v-btn @click="tac = false">close</v-btn>
          </div>
        </div>
      </div>
    </v-fade-transition>

    <v-fade-transition>
      <div class="tac-overlay" v-show="contact">
        <div class="tac-content">
          <v-card elevation="10">
            <v-card-title
              ><span
                ><img
                  :src="require('../assets/images/logo_notext.png')"
                  alt="logo"
                  style="cursor: pointer"
                  contain
                  class="shrink mr-2 cursor-change"
                  transition="scale-transition"
                  width="50"/></span
              ><b>Contact riparian.info</b></v-card-title
            >
            <v-card-text>
              <div class="text-lg-center">
                Need help or have a question/comment? Send us an email:<br />
                <v-btn
                  flat
                  href="mailto:contact@riparian.info"
                  style="text-transform: unset !important;"
                  ><h3>contact@riparian.info</h3></v-btn
                >
              </div>
              <div class="text-lg-center">
                <v-btn flat @click="contact = false" color="warning"
                  >close</v-btn
                >
              </div>
            </v-card-text>
          </v-card>
        </div>
      </div>
    </v-fade-transition>
  </v-app>
</template>

<script>
import AmplifyAuth from "../components/AmplifyAuth";
import { Auth } from "aws-amplify";
import NavButtons from "@/components/NavButtons";

export default {
  name: "Landing",

  components: {
    NavButtons,
    AmplifyAuth,
  },

  data() {
    return {
      windowWidth: window.innerWidth,
      tac: false,
      contact: false,
      contactMessage: null,
      contactEmail: null,
    };
  },

  computed: {
    authenticated() {
      return this.$store.state.settings.authenticated;
    },
    adminUsers() {
      return this.$store.state.settings.adminUsers;
    },
    showLogin() {
      return this.$store.state.settings.showAuth;
    },
  },

  methods: {
    signOut() {
      Auth.signOut()
        .then(() => {
          this.$store.commit("settings/changeAuth", {
            authenticated: false,
            user: null,
          });
        })
        .catch(() => {});
    },
    changeAuthModal(value) {
      this.$store.commit("settings/toggleAuthModal", value);
    },
    sendEmail() {
      if (this.$refs.form.validate()) {
        // pass
        this.contact = false;
      }
    },
  },

  mounted() {
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
  },
};
</script>

<style scoped>
.auth-modal {
  position: fixed;
  margin: auto;
  top: 60px;
  z-index: 11;
}
.doc-frame {
  margin: 0 auto;
  width: 100%;
  height: 600px;
}
.tac-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9997;
}
.tac-content {
  position: relative;
  top: 10%;
  transform: translateY(-50%);
  left: 50%;
  transform: translateX(-50%);
  width: 600px;
  z-index: 9998;
}
</style>
